import { atomFamily, atomWithRefresh } from 'jotai/utils';
import { guardedClient } from '../../../auth/api/clients';
import { advisorSchema } from '@minutes-system/backend/src/api/advisors/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';

export const advisorQueryAtom = atomFamily((advisorId: number) =>
  atomWithRefresh(() =>
    fetchAndValidate(
      guardedClient.advisors[':id'].$get({ param: { id: String(advisorId) } }) as Promise<Response>,
      advisorSchema
    )
  )
);
